var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H14.6124L15.3632 11.25H20V15Z",
    fill: "#F5CD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51257 20H0.487549L1.73694 13.75H6.76196L5.51257 20Z",
    fill: "#FFDA6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6381 6.25H12.613L13.8624 0H18.8875L17.6381 6.25Z",
    fill: "#FFDA6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8876 20H9.86255L12.3619 7.5H17.387L14.8876 20Z",
    fill: "#FFDA6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01184 8.75H0V5H4.76257L4.01184 8.75Z",
    fill: "#F5CD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.75H6.48743L7.23816 5H20V8.75Z",
    fill: "#F5CD00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1.25V1.25H0V0Z",
    fill: "#F5CD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75H20V20H18.75V18.75Z",
    fill: "#F5CD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01306 12.5H1.98804L4.48743 0H9.51245L7.01306 12.5Z",
    fill: "#FFDA6B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6125 11.25H0V15H10.8624L11.6125 11.25Z",
    fill: "#F5CD00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.f611645013b9631aef112327c07b9f7e.svg";
export { ForwardRef as ReactComponent };